import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const ForwardCases = lazy(() => import('./ForwardCases.jsx'))
const ForwardCaseDetails = lazy(() => import('./FwdCaseDetailsView.jsx'))

const ForwardCasesRoutes = [
    {
        path: '/ForwardCases',
        component: ForwardCases,
        auth: authRoleAccess.org_head_case_management,
    },
    {
        path: '/forwarded-cases/:id',
        component: ForwardCaseDetails,
        auth: authRoleAccess.org_head_case_management,
    },
]

export default ForwardCasesRoutes
